module.exports = __webpack_public_path__ + "static/pd1-af278e3dd77798eeff9feacf77e92e43.png";